<template>
  <div>
    <div id="shareBoxWidget" class="share-box share-box--private" v-click-outside="onClickOutside"  v-if="checkIfPrivate">
    <social-sharing
        :url="shareUrl"
        :title="shareTitle"
        :description="shareDesc"
        :quote="shareQuote"
        :hashtags="shareHashtags"
        inline-template
      >
        <div>
          <network network="email" class="share-box__item share-box__item--mail">
            <i class="icon-podcast icon-podcast-mail"></i>
          </network>
        </div>
      </social-sharing>
    </div>
    <div id="shareBoxWidget" class="share-box" v-click-outside="onClickOutside"  v-else>
    <social-sharing
      :url="shareUrl"
      :title="shareTitle"
      :description="shareDesc"
      :quote="shareQuote"
      :hashtags="shareHashtags"
      inline-template
    >
       <div>
        <network network="twitter" class="share-box__item share-box__item--twitter">
          <i class="icon-podcast icon-podcast-twitter"></i>
        </network>
        <network network="facebook" class="share-box__item share-box__item--facebook">
          <i class="icon-podcast icon-podcast-facebook"></i>
        </network>
        <network network="linkedin" class="share-box__item share-box__item--linkedin">
          <i class="icon-podcast icon-podcast-linkedin"></i>
        </network>
        <network network="email" class="share-box__item share-box__item--mail">
          <i class="icon-podcast icon-podcast-mail"></i>
        </network>
        <network network="whatsapp" class="share-box__item share-box__item--whats-app" >
          <i class="icon-podcast icon-podcast-whats-app"></i>
        </network>
      </div>
    </social-sharing>
    <button class="share-box__item share-box__item--link" @click="showCopyLink = true">
      <i class="icon-podcast icon-podcast-link"></i>
    </button>
    <transition name="share-box__copylink-animation">
      <div class="share-box__copylink" v-if="showCopyLink">
        <span class="share-box__copylink-url">{{ shareUrl }}</span>
        <i class="icon-share icon-share-link"></i>
        <span
          class="share-box__copylink-button"
          v-clipboard="this.shareUrl"
          v-clipboard:success="clipboardSuccessHandler"
          v-clipboard:error="clipboardErrorHandler"
        >{{ copyLinkStatus }}<i v-if="showIconCopied" class="icon-share icon-share-check"></i></span>
        <span
          class="share-box__copylink-close icon-close"
          @click="showCopyLink = false"
        ></span>
      </div>
    </transition>
  </div>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside'

export default {
  name: 'ShareBox',
  data () {
    return {
      sharePrivate: false,
      positionButton: '',
      showCopyLink: false,
      showIconCopied: false,
      copyLinkStatus: 'COPY'
    }
  },
  props: {
    shareUrl: {
      type: String,
      required: true
    },
    shareTitle: {
      type: String,
      required: true
    },
    shareHashtags: {
      type: String
    },
    shareQuote: {
      type: String
    },
    shareDesc: {
      type: String
    }
  },
  mounted () {
        setTimeout(() => {
          var position = this.checkPositionButton - ((document.getElementById('shareBoxWidget').clientWidth) / 2);
          document.getElementById('shareWidget').style.left = position + "px";
          console.log("j'affiche le popup");
    }, 500)
     
  },
  computed: {
    checkIfPrivate() {
       this.sharePrivate = this.$parent.isPrivate
       return this.sharePrivate
    },
    checkPositionButton() {
       this.positionButton = this.$parent.positionLeftShareButton
       return this.positionButton
    }
  },
  methods: {
    onClickOutside (event) {
      this.$parent.showShareBox = false
      setTimeout(() => {
        if (event.target.classList.contains('icon-podcast')) {
          this.$parent.showShareBox = true
        } else {
         this.$parent.showShareBox = false
        }
      }, 500)
    },
    clipboardSuccessHandler ({ value, event }) {
      this.copyLinkStatus = ''
      this.showIconCopied = true

      setTimeout(() => {
        this.showCopyLink = false
        this.showIconCopied = false
        this.copyLinkStatus = 'COPY'
      }, 1000)
    },
    clipboardErrorHandler ({ value, event }) {
      this.copyLinkStatus = 'ERROR!'
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  }
}
</script>

<style lang="scss">
//SHARING MODAL

.share-box {
  z-index: 1000;
  position: relative;
  top: -75px;
  left: 140px;
  @media screen and (max-width: 500px) {
    left: 124px;
  }
  &.share-box--private{
    left: 0 !important;
    &:before{
      left:50% !important;
    }
    &:after{
      left:50% !important;
    }
  }
  box-sizing: border-box;
  background: #fff;
  height: 60px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.24);
  border-radius: 5px;
  padding: 12px;
  display: table;

  & > div {
    display: inline-block;
  }
  &:before {
    width: 0;
    height: 0;
    border-left: 8.5px solid transparent;
    border-right: 8.5px solid transparent;
    border-top: 7px solid #dddddd;
    content: "";
    position: absolute;
    display: block;
    bottom: -10px;
    left: 15px;
    filter: blur(2px);
  }
  &:after {
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 7px solid white;
    content: "";
    position: absolute;
    display: block;
    bottom: -7px;
    left: 15px;
  }
  &__item {
    vertical-align: top;
    display: inline-block;
    border: 1px solid #e8e8e8;
    cursor: pointer;
    border-radius: 36px;
    margin: 0 6px;
     @media screen and (max-width: 500px) {
      margin: 0 3px;
    }
    width: 36px;
    height: 36px;
    text-align: center;
    &:focus {
      outline: none;
    }
    i {
      font-style: normal;
    }
    .icon-podcast {
      text-decoration: none;
      line-height: 36px;
      font-size: 18px;
      &:hover {
        text-decoration: none;
      }
    }
    &--twitter {
      &:hover {
        background: map-get($social-colors, "twitter");
        border: 1px solid map-get($social-colors, "twitter");
        color: #fff;
        .icon-podcast {
          color: #fff;
        }
      }
    }
    &--facebook {
      &:hover {
        background: map-get($social-colors, "facebook");
        border: 1px solid map-get($social-colors, "facebook");
        color: #fff;
        .icon-podcast {
          color: #fff;
        }
      }
    }
    &--linkedin {
      &:hover {
        background: map-get($social-colors, "linkedin");
        border: 1px solid map-get($social-colors, "linkedin");
        color: #fff;
        .icon-podcast {
          color: #fff;
        }
      }
    }
    &--whats-app {
      &:hover {
        background: map-get($social-colors, "whats-app");
        border: 1px solid map-get($social-colors, "whats-app");
        color: #fff;
        .icon-podcast {
          color: #fff;
        }
      }
    }
    &--mail {
      &:hover {
        background: #4a4a4a;
        border: 1px solid #4a4a4a;
        color: #fff;
        .icon-podcast {
          color: #fff;
        }
      }
    }
    &--link {
      &:hover {
        background: #00915a;
        border: 1px solid #00915a;
        color: #fff;
        .icon-podcast,
        .icon-share {
          color: #fff;
        }
      }
    }
    .icon-podcast-twitter {
      color: map-get($social-colors, "twitter");
      font-size: 22px;
    }
    .icon-podcast-mail {
      color: #4a4a4a;
      font-size: 14px;
    }
    .icon-podcast-link,
    .icon-share-link {
      color: #4a4a4a;
      font-size: 14px;
    }
    .icon-podcast-link,
    .icon-share-link {
      color: #00915a;
    }
    .icon-podcast-facebook {
      color: map-get($social-colors, "facebook");
    }
    .icon-podcast-whats-app {
      color: map-get($social-colors, "whats-app");
    }
    .icon-podcast-linkedin {
      color: map-get($social-colors, "linkedin");
    }
  }
  .share-box__copylink {
    padding-top: 10px;
    padding-left: 10px;
    box-sizing: border-box;
    width: 100%;
    border-radius: 5px;
    position: absolute;
    height: 60px;
    color: #5f5f5f;
    top: 0;
    left: 0;
    background: #fff;
    &-animation-enter,
    &-animation-leave-to {
      opacity: 0;
      transform: translateX(-5px);
    }
    &-animation-leave-active,
    &-animation-enter-active {
      transition: all 1s;
    }
    .icon-podcast-link,
    .icon-share-link {
      position: absolute;
      left: 17px;
      font-size: 15px;
      top: 21px;
      color: #00915a;
    }
    &-url {
      font-size: 14px;
      height: 40px;
      line-height: 40px;
      vertical-align: top;
      width: 195px;
      @media screen and (max-width: 500px) {
        width: 165px;
      }
      padding: 0;
      box-sizing: border-box;
      padding-left: 30px;
      margin: 0;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      border: 1px solid #ccc;
    }
    &-button {
      width:60px;
      vertical-align: top;
      cursor: pointer;
      background: #00915a;
      text-align: center;
      font-size: 13px;
      line-height: 40px;
      height: 40px;
      color: #fff;
      display: inline-block;
      vertical-align: top;
      padding: 0 10px;
      &:hover {
        transition: background-color 0.5s ease;
        background: #5f5f5f;
      }
    }
    &-close {
      font-size: 20px;
      vertical-align: top;
      margin-left: 10px;
      cursor: pointer;
      height: 40px;
      line-height: 40px;
      &:hover {
        color: #00915a;
      }
    }
  }
}
</style>
